import { render, staticRenderFns } from "./postPurchaseChurnTrend.vue?vue&type=template&id=3e984ca2&scoped=true&"
import script from "./postPurchaseChurnTrend.vue?vue&type=script&lang=js&"
export * from "./postPurchaseChurnTrend.vue?vue&type=script&lang=js&"
import style0 from "./postPurchaseChurnTrend.vue?vue&type=style&index=0&id=3e984ca2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e984ca2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e984ca2')) {
      api.createRecord('3e984ca2', component.options)
    } else {
      api.reload('3e984ca2', component.options)
    }
    module.hot.accept("./postPurchaseChurnTrend.vue?vue&type=template&id=3e984ca2&scoped=true&", function () {
      api.rerender('3e984ca2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/postPurchaseChurnTrend.vue"
export default component.exports